module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-2@2x-3c24154dda13cd0b106c511f21281aa9.png";